var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCard',{attrs:{"title":"Recently played"}},[_c('BaseProfileTable',{attrs:{"scoreList":_vm.scores}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }